export const STATIC_REPLIES = {
  "Jag vill hitta rätt utbildning - var börjar jag?":
    "Vad kul att du är intresserad av utbildning!\nFör att kunna ge dig bästa förslag – vilken roll har du inom städbranschen?",
  "Jag vill utbilda min personal eller mitt team - kan ni hjälpa mig?":
    "Absolut! Vi hjälper gärna till med att utbilda grupper och team.\nHur stort är teamet du vill utbilda, och vilken typ av innehåll är du intresserad av?",
  "Jag vill veta mer om era konsulttjänster - kan ni guida mig?":
    "Självklart! Våra konsulttjänster täcker in upphandling, utredning och uppföljning.\nVad är du mest intresserad av just nu?",
};
